( function(root, factory) {
    if ( typeof define === 'function' && define.amd) {
        define('mmc.libs.Get',['jquery'], factory);
    } else if ( typeof exports === 'object') {
        module.exports = factory(require('jquery'));
    } else {
        if ( typeof root.MMCLIBS === 'object') {
            root.MMCLIBS.Get = factory(root.$);
        } else {
            root.Get = factory(root.$);
        }
    }
}(this, function($) {
    // END UMD-PATTERN

    function Get( _window)
    {

        var get = {

            _window : window,

            init : function(_window)
            {

                if (typeof _window !== 'undefined') {
                    this._window = _window;
                }

            },
            param : function(param)
            {

                var query = this._window.location.search.substring(1);
                var vars = query.split('&');

                for (var i=0;i<vars.length;i++) {

                    var pair = vars[i].split('=');

                    if (pair[0] === param) {
                        return decodeURIComponent(pair[1]);
                    }
                }

                return null;

            },
            params : function() {

                var query = this._window.location.search.substring(1);
                var vars = query.split('&');
                var pairs = [];

                for (var i=0;i<vars.length;i++) {

                    var pair = vars[i].split('=');
                    pairs[pair[0]] = decodeURIComponent((pair[1]));

                }

                return pairs;

            }

        };

        get.init(_window);

        return get;

    }

    return Get;

}));

